const admin = {
    breadcrumb: {
        title: {
            site: 'Site Settings',
        },
        shortcut: {
            home: 'Home',
            site: 'Sites',
            'site-edit': 'Edit Site',
        },
    },
    columns: {
        title: 'TITLE',
        description: 'DESCRIPTION',
        name: 'NAME',
        advertiser: 'ADVERTISER',
        cost: 'COST',
        subDomain: 'SUBDOMAIN',
        country: 'COUNTRY',
        gender: 'GENDER',
        firstname: 'FIRSTNAME',
        lastname: 'LASTNAME',
        email: 'EMAIL',
        status: 'STATUS',
        company: 'COMPANY',
        abbreviation: 'ABBREVIATION',
        abbreviationExt: 'ABBREVIATION EXT.',
        language: 'SPEAKING LANG.',
        publisher: 'PUBLISHER',
        affiliate: 'AFFILIATE',
        manager: 'MANAGER',
        smartCpa: 'SMART CPA',
        capping: 'CAPPING',
        defaultCost: 'DEFAULT COST',
        customCost: 'CUSTOM COST',
        startDate: 'START DATE',
        campaign: 'CAMPAIGN',
        smartValue: 'SMART VALUE',
        counter: 'COUNTER',
        totalCounter: 'TOTAL COUNTER',
        totalCut: 'TOTAL CUT',
        updatedAt: 'UPDATED AT',
        createdAt: 'CREATED AT',
        operator: 'OPERATOR',
        fieldname: 'FIELD NAME',
        fieldvalue: 'FIELD VALUES',
        endpoint: 'ENDPOINT',
        method: 'METHOD',
        revenueType: 'REVENUE TYPE',
        revenueAmount: 'REVENUE AMOUNT',
        globalCapping: 'GLOBAL CAPPING',
        periodCapping: 'PERIOD CAPPING',
        currency: 'CURRENCY',
        url: 'URL',
        type: 'TYPE',
        defaultRevenue: 'DEFAULT REVENUE',
        customRevenue: 'CUSTOM REVENUE',
        offer: 'OFFER',
        setBy: 'SET BY',
        categories: 'CATEGORIES',
        noCategories: 'No categories',
        endpoint_production: 'Endpoint Production',
        endpoint_sandbox: 'Endpoint Sandbox',
        role: 'ROLE',
        actions: 'ACTIONS',
        targetUsers: 'TARGET USERS',
        formulaType: 'FORMULA TYPE',
        validity: 'VALIDITY',
        issueCode: 'ISSUE CODE',
        migrationSeverity: 'SEVERITY',
        stage: 'STAGE',
        source: 'SOURCE',
        issueMessage: 'MESSAGE',
        migrationSite: 'SITE',
        payload: 'PAYLOAD',
        accountManager: 'ACCOUNT MANAGER',
        businessDev: 'BUSINESS DEV',
    },
    form: {
        campaign: {
            failConfig: {
                label: 'Config Required',
                tooltip: 'Internal campaign has no linked Order campaign. Edit the campaign to set one.',
            },
        },
        status: {
            draft: 'Draft',
            active: 'Active',
            inactive: 'Inactive',
            paused: 'Paused',
            pending: 'Pending',
            finished: 'Finished',
            undefined: 'No status',
            review: 'Review',
        },
        tabs: {
            userInfo: 'User Info',
            users: 'Users',
            offers: 'Offers',
            contacts: 'Contacts',
            trackingParameters: 'Tracking Parameters',
            columnMappingVisual: 'Visual builder',
            columnMappingJson: 'JSON editor',
        },
        sections: {
            userInformation: 'User Information',
            users: 'Users',
            offers: 'Offers',
            contacts: 'Contacts',
            trackingParameters: 'Tracking Parameters',
            trackingDomains: 'Tracking Domains',
        },
        title: {
            user: 'User details',
            offer: 'Offer details',
            order: 'Order details',
            advertiser: 'Advertiser details',
            publisher: 'Publisher details',
            affiliate: 'Affiliate details',
            smartCpa: 'Smart Cpa details',
            category: 'Category details',
            campaign: 'Campaign details',
            lead: 'Lead details',
            extraParams: 'Add an extra param',
            customPayout: 'Manage custom payouts for {campaign}',
            site: 'Site details',
            filter: 'Filter details',
            connector: 'Connector details',
            newSetting: 'Create new google auth',
            newApiEndpoint: 'Create new api endpoint',
            apiEndpoints: 'Api endpoints details',
            prelander: 'Prelander details',
            devalidationImport: 'Devalidation Import',
            createCampaignOffer: 'Create a new campaign with offers',
            createCampaignOrder: 'Create a new campaign with orders',
            customRevenue: 'Manage custom revenues for {campaign}',
            addCustomPayout: 'Add custom payout',
            managePayouts: 'Manage payouts',
            addCustomCappings: 'Add custom cappings',
            manageCappings: 'Manage cappings',
            addComponent: 'Add a new component',
            editComponent: 'Edit component',
            customCappings: 'Manage custom publisher cappings for {campaign}',
            profile: 'Profile settings',
            migrationIssues: 'Migration issues',
        },
        titleHelper: {
            user: 'Give the details of the user, role, speaking language and other information needed to set a campaign',
            offer: 'Give the details of the offer, title, status and other information needed to set an offer',
            order: 'Give the details of the order, advertiser, cost and other information needed to set an order',
            advertiser: 'Give the details of the advertiser, company, address, speaking language and other information needed to set an advertiser',
            publisher: 'Give the details of the publisher, company, address, speaking language and other information needed to set a publisher',
            affiliate: 'Give the details of the affiliate, name, company, email and other information needed to set an affiliate',
            smartCpa: 'Give the details of the smart cpa, campaign, affiliate and other information needed to set a smart cpa',
            category: 'Give the details of the category, name, status, information needed to set a category',
            campaign: 'Give the details of the campaign, dates, cost and other information needed to set a campaign',
            site: 'Give the details of the site, name, domain and other information needed to set a site',
            connector: 'Give the details of the connector, name, type, endpoint and other information needed to set a connector',
            apiEndpoints: 'Give the details of the api endpoint, name, type, endpoint and other information needed to set an api endpoint',
            prelander: 'Give the details of the prelander, title, url and other information needed to set a prelander',
            devalidationImport: 'Import devalidation data from CSV files to process commission adjustments and clawbacks',
            createCampaignOffer: 'Campaign with tracking links, prelanders or/and landing pages',
            createCampaignOrder: 'Campaign with lead orders, filters or/and capping',
            commissionPlan: 'Give the details of the commission plan, name, target users, role, formula type and other information needed to set a commission plan',
            profile: 'Update your profile information, change your password, and manage your account settings',
            migrationIssues: 'Review issues recorded during legacy project migration, update triage status, or clear resolved rows.',
        },
        stepper: {
            campaign: {
                details: 'Details',
                offerType: 'Offer Type',
                tracking: 'Tracking',
                targeting: 'Targeting/Redirect',
                prelanders: 'Prelanders',
                offers: 'Offers',
                orders: 'Orders',
            },
            order: {
                details: 'Details',
                filters: 'Filters',
                extra: 'Extra Filters',
                connectors: 'Connectors',
                campaigns: 'Campaigns',
            },
            site: {
                details: 'Details',
                tracking: 'Tracking',
                roles_permissions: 'Roles & Permissions',
            },
            connector: {
                authentification: 'Authentification',
                data: 'Data',
                response: 'Api response',
            },
            buttons: {
                prev: 'Previous',
                next: 'Next',
            },
        },
        fieldsets: {
            user: {
                details: 'Set user details',
            },
            offer: {
                details: 'Set offer details',
            },
            prelander: {
                details: 'Set prelander details',
            },
            order: {
                details: 'Set order details',
                capping: 'Set capping details',
                filters: 'Set filters details',
                extra: 'Set filters details',
                connectors: 'Set connectors details',
                campaigns: 'Associated campaigns',
                campaignsEmpty: 'No campaigns associated with this order yet.',
                campaignsNoResult: 'No campaigns found.',
            },
            advertiser: {
                details: 'Set advertiser details',
                trackingParams: 'Tracking Parameters',
            },
            publisher: {
                details: 'Set publisher details',
            },
            affiliate: {
                details: 'Set affiliate details',
            },
            smartCpa: {
                details: 'Set smart cpa details',
            },
            category: {
                details: 'Set category details',
            },
            profile: {
                details: 'Profile information',
                password: 'Change password',
            },
            campaign: {
                details: 'Set campaign details',
                offerType: 'Choose offer type',
                trackingLink: 'Get a tracking link',
                generate: 'Generate Tracking Link and API Endpoint documentation',
                dateCostScrub: 'Set dates, cost and model',
                tracking: 'Set tracking',
                targeting: 'Set targeting',
                targetingType: 'Set targeting type, geo',
                targetingGeo: 'Set redirect',
                offers: 'Set offers',
                orders: 'Set orders',
                prelanders: 'Set prelanders',
                advertiser: 'Advertiser',
                revenue: 'Revenue',
                postback: 'Get a postback',
                campaignToCampaign_offer: 'Select campaign Order to link',
                campaignToCampaign_order: 'Select campaign Offer to link',
            },
            site: {
                details: 'Set site details',
                smtp: 'Set smtp details',
                tracking: 'Available Tracking Domains',
                roles_permissions: 'Roles & Permissions',
            },
            connector: {
                basic: 'Basic information',
                restApi: 'REST API Configuration',
                pipeline: 'Pipeline Configuration',
                test: 'Test Configuration',
                authentification: 'Set auth and details',
                data: 'Set data details',
                apiResponse: 'Set api response details',
                notification: 'Set notification details',
                production: 'Production',
                sandbox: 'Sandbox',
            },
            apiEndpoints: {
                details: 'Set api endpoints details',
            },
        },
        offerType: {
            internal: {
                title: 'Internal',
                description: 'Link with an Order campaign. Has API. Click converts on lead delivery.',
            },
            external: {
                title: 'External',
                description: 'Redirects externally. No Order, no API. Click converts via advertiser postback.',
            },
        },
        offerTypeSwitch: {
            title: 'Remove linked Order campaign?',
            body: 'Switching to External will permanently remove the linked Order campaign from this campaign. This cannot be undone. Are you sure?',
            confirm: 'Yes, switch to External',
            cancel: 'Cancel',
        },
        fields: {
            manager: 'Manager',
            startDate: 'Start date',
            endDate: 'End date',
            campaign: 'Campaign',
            campaigns: 'Campaigns',
            capping: 'Capping',
            offers: 'Offers',
            orders: 'Orders',
            offer: 'Offer',
            url: 'Url',
            model: 'Model',
            share: 'Share',
            revenue: 'Revenue',
            advertiser: 'Advertiser',
            campaignType: 'Campaign type',
            costAmount: 'Cost',
            priority: 'Priority',
            banner: 'Banner',
            dateRetention: 'Date retention',
            timeRetention: 'Data Time retention (in minutes)',
            ageMin: 'Age min',
            ageMax: 'Age max',
            emails: 'Emails',
            zipCodes: 'Zip codes',
            emailsValues: 'List of emails (One per line!)',
            zipcodesValues: 'List of zip codes (One per line!)',
            sources: 'Source IDs',
            sourceidsValues: 'List of source IDs (One per line!)',
            extraParams: 'Extra params',
            value: 'value',
            currency: 'Currency',
            costType: 'Model',
            traffic: 'Traffic type',
            protocol: 'Protocol',
            previewLink: 'Preview url',
            categories: 'Categories',
            category: 'Category',
            cut: 'Scrub',
            geoTargeting: 'Geo targeting',
            geoRedirect: 'Geo redirect',
            forceRedirect: 'Force redirect',
            redirect: 'Redirect',
            title: 'Title',
            description: 'Description',
            gender: 'Gender',
            name: 'Name',
            firstname: 'Firstname',
            lastname: 'Lastname',
            fullname: 'Fullname',
            birthdate: 'Birthdate',
            phone: 'Phone',
            subDomain: 'Subdomain',
            emailBody: 'Email content',
            address: 'Address',
            address2: 'Additional address',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipcode: 'Zip code',
            ip: 'Ip',
            email: 'Email',
            status: {
                label: 'Status',
                active: 'Active',
                inactive: 'Inactive',
            },
            site: 'Site',
            language: 'Language',
            role: 'Role',
            oldPassword: 'Current password',
            password: 'Password',
            confirmPassword: 'Confirm password',
            company: 'Company',
            abbreviation: 'Abbreviation',
            abbreviationExt: 'Abbreviation Ext.',
            zipCode: 'Zip code',
            vat: 'Vat Number',
            companyNumber: 'Company Number',
            accountManager: 'Account Manager',
            businessDev: 'Business Dev',
            operators: 'Operators',
            values: 'Value',
            publishers: 'Publishers',
            publisher: 'Publisher',
            smartValue: 'Smart value',
            counter: 'Counter',
            totalCounter: 'Total counter (lifetime)',
            totalCut: 'Total cut (lifetime)',
            affiliate: 'Affiliate',
            domain: 'Domain',
            siteCategory: 'Site category',
            siteType: 'Site type',
            filter: 'Filter',
            param: 'Param',
            connector: 'Connector',
            integrationType: 'Integration type',
            method: 'Method',
            authType: 'Auth type',
            field: 'Field',
            formatDate: 'Date format',
            separator: 'Separator',
            data: 'Data',
            config: 'config',
            authConfig: 'Auth config',
            spreadId: 'Spread ID',
            sheetName: 'Sheet Name',
            range: 'Range',
            googleSheets: {
                authMethod: 'Authentication method',
                serviceAccountFile: 'Service account JSON file',
                serviceAccountJson: 'Service account JSON',
                impersonateUser: 'Impersonate user (optional)',
                spreadsheetId: 'Spreadsheet ID',
                sheetName: 'Sheet name',
                headerRow: 'Header row',
                checkColumns: 'Duplicate check columns',
                includeTimestamp: 'Include timestamp column',
                timestampColumn: 'Timestamp column name',
                timestampFormat: 'Timestamp format',
                payloadSource: 'Payload source',
                sheetColumn: 'Sheet column (header)',
                mappingType: 'Mapping type',
                leadField: 'Lead field',
                defaultValue: 'Default value',
                template: 'Template',
                concatenateFields: 'Fields to concatenate (comma-separated)',
                separator: 'Separator',
            },
            nameTest: 'Name of value',
            operator: 'Operator',
            valueTest: 'Value',
            type: 'Type',
            userStatus: 'User Status',
            lastLogin: 'Last Login',
            offerName: 'Offer Name',
            payout: 'Payout',
            dateCreated: 'Date Created',
            actions: 'Actions',
            position: 'Position',
            department: 'Department',
            birthday: 'Birthday',
            newsletterSubscription: 'Newsletter Subscription',
            from: 'From',
            to: 'To',
            parameter: 'Parameter',
            additionalInfo: 'Additional info',
            dynamicValues: 'Available Dynamic values',
            isDefault: 'Default',
            default: 'Default',
            setAsDefault: 'Set as default domain',
            isEnabled: 'Status',
            enabled: 'Enabled',
            disabled: 'Disabled',
            setAsEnabled: 'Enable this domain',
            prelanders: 'Prelanders',
            prelander: 'Prelander',
            hideReferer: 'Hide referer',
            max_coreg: 'Max coreg',
            max_order: 'Max order',
            trackingLink: 'Tracking link',
            total: 'Total',
            limit: 'Limit',
            filtering: 'Filtering',
            targetUsers: 'Target Users',
            formulaType: 'Formula Type',
            validity: 'Validity',
            geoTargetingBehaviour: 'What should the tracking do when the enduser is not in the targeting country ?',
            useAsRedirect: 'Use as redirect',
            endpoint: 'Endpoint URL',
            endpointMode: 'Endpoint mode',
            endpointPathSuffix: 'Endpoint path suffix',
            authFetchEndpoint: 'Token fetch endpoint',
            authFetchMethod: 'Token fetch method',
            authFetchBodyFormat: 'Request body format',
            authFetchPayload: 'Token fetch payload (JSON)',
            authFetchHeaders: 'Extra fetch headers (JSON array)',
            authTokenResponsePath: 'Token response path',
            authTokenHeader: 'Authorization header name',
            authTokenPrefix: 'Token header prefix',
            authResponsePaths: 'Auth response paths (JSON)',
            username: 'Username',
            token: 'Token',
            headerName: 'Header Name',
            headerValue: 'Header Value',
            sendLeadEndpoint: 'Send lead endpoint',
            sendLeadMethod: 'Send lead method',
            payloadSource: 'Payload source key',
            sendLeadSuccessHttpCodes: 'Success HTTP codes',
            sendLeadSuccessResponsePath: 'Success response path',
            checkExistenceEndpoint: 'Check existence endpoint',
            checkExistenceMethod: 'Check existence method',
            checkExistencePayloadSource: 'Check existence payload source',
            checkExistenceSuccessHttpCodes: 'Success HTTP codes',
            checkExistenceSuccessResponsePath: 'Success response path',
            notificationType: 'Notification type',
            notificationUrl: 'Notification url',
            smtpHost: 'SMTP Host',
            smtpPort: 'SMTP Port',
            smtpUsername: 'SMTP Username',
            smtpPassword: 'SMTP Password',
            smtpEncryption: 'SMTP Encryption',
            smtpFromEmail: 'SMTP From Email',
            notificationEmails: 'Notification emails',
            select_parameter: 'Select a parameter',
            roles: 'Roles',
            permissions: 'Permissions',
            system: 'System role',
        },
        helpers: {
            advertiser: 'Select an advertiser',
            notification: 'Notification',
            notificationType: 'Notification type',
            notificationUrl: 'Notification url',
            notificationTestSuccess: 'Notification test successful',
            notificationTestError: 'Notification test failed',
            text: 'Enter {entity}',
            select: 'Select a {entity}',
            search: 'Search {entity}',
            status: 'Select a status',
            site: 'Select a site',
            language: 'Select a language',
            country: 'Select a country',
            state: 'Select a state',
            role: 'Select a role',
            gender: 'Select a gender',
            connector: 'Select a connector',
            method: 'Select a method',
            authType: 'Select auth type',
            field: 'Select a field',
            formatDate: 'Select a format of date',
            operator: 'Select an operator',
            createUser: 'Create a new user',
            notificationEmails: 'Enter email',
            passwordOptional: 'Leave empty to keep current password',
            password: 'Enter a secure password',
            confirmPassword: 'Confirm your new password',
            campaignCappings: 'Set to 0 to disable capping',
            noEndDate: 'No end date',
            googleSheets: {
                serviceAccountJson: 'Paste service account JSON or upload a file',
                spreadsheetId: 'From the Google Sheets URL: /d/{spreadsheetId}/edit',
                checkColumnPlaceholder: 'e.g. email',
            },
            integrationType: {
                api: 'Send leads to external APIs with authentication, payload mapping, and HTTP delivery.',
                googleSheets: 'Append leads to a Google Spreadsheet using a service account and column mapping.',
            },
            targeting: {
                trafficType: 'Restricts which device types can enter this campaign. Clicks from other device types return a 204 (no content) and are not tracked.',
                country: 'Limit this campaign to a single country, detected via IP geolocation. Clicks from other countries follow the behaviour set below.',
                geoTargetingBehaviour: 'What happens when a click arrives from a country other than the one targeted above. {blocked} returns a 204 and drops the click.',
                forceRedirect: 'When {yes}, all incoming traffic is immediately redirected to the campaign below — before any geo check, offer selection, or capping. The redirect target must be Active and must not itself have Force Redirect enabled.',
                redirectCampaign: 'Campaign to send all traffic to when Force Redirect is {yes}. Searches Active campaigns by title; optionally filtered by the selected country above.',
                geoRedirect: 'How to handle out-of-geo traffic:',
                geoRedirectDisabled: 'No redirect, click proceeds normally.',
                geoRedirectGlobal: 'Send to the offer/prelander flagged {useAsRedirect} (set below). Requires at least one offer or prelander already added.',
                geoRedirectCountry: 'Find the closest Active campaign that matches this campaign\'s categories and cost type but targets the visitor\'s actual country, then redirect there.',
                useAsRedirect: 'Offer (and/or prelander) that acts as the fallback destination when Geo Redirect is {global}. Only active pivot entries are eligible.',
            },
        },
        options: {
            integrationType: {
                api: 'REST API',
                googleSheets: 'Google Sheets',
            },
            endpointMode: {
                static: 'Static URL',
                dynamicFromAuth: 'Dynamic (from auth)',
            },
        },
        descriptions: {
            googleSheetsAuth: 'Authenticate with Google Sheets using a service account',
            checkRowExists: 'Check whether a row already exists before appending',
            appendToSpreadsheet: 'Map lead fields to spreadsheet columns and append a row',
        },
        actions: {
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            duplicate: 'Duplicate',
            remove: 'Remove',
            review: 'Review',
            active: 'Active',
            block: 'Block',
            reject: 'Reject',
            impersonate: 'Impersonate',
            addValue: 'Add a value',
        },
        buttons: {
            addUser: 'Add a new user',
            addOffer: 'Add a new offer',
            addOrder: 'Add a new order',
            addAdvertiser: 'Add a new advertiser',
            addPublisher: 'Add a new publisher',
            addAffiliate: 'Add a new affiliate',
            addSmartCpa: 'Add a new smart cpa',
            addEmail: 'Add a recipient email',
            addCategory: 'Add a new category',
            addCampaign: 'Add a new campaign',
            addLead: 'Add a new lead',
            addFilter: 'Add a new filter',
            addConnector: 'Add a new connector',
            addApiEndpoint: 'Add a new api endpoint',
            addContact: 'Add Contact',
            addParameter: 'Add Parameter',
            addPrelander: 'Add a new prelander',
            addRole: 'Add Role',
            addTrackingDomain: 'Add Tracking Domain',
            edit: 'Edit',
            delete: 'Delete',
            enable: 'Enable',
            backToUser: 'Back to Users List',
            backToOffer: 'Back to Offers List',
            backToOrder: 'Back to Orders List',
            backToAdvertiser: 'Back to Advertisers List',
            backToPublisher: 'Back to Publishers List',
            backToAffiliate: 'Back to Affiliates List',
            backToSmartCpa: 'Back to Smart Cpa List',
            backToCategory: 'Back to Categories List',
            backToCampaign: 'Back to Campaigns List',
            backToLead: 'Back to Leads List',
            backToConnector: 'Back to Connectors List',
            backToApiEndpoints: 'Back to API Endpoints List',
            backToPrelanders: 'Back to Prelanders List',
            backToDevalidationImport: 'Back to Devalidation Import',
            save: 'Save',
            copy: 'Copy',
            customPayout: 'CUSTOM PAYOUT',
            customRevenue: 'CUSTOM REVENUE',
            distributeShare: 'Distribute share from this',
            generateApiEndpointDocumentation: 'Generate API Endpoint documentation for {publisher}',
            addCapping: 'Add capping',
            customCapping: 'CUSTOM CAPPING',
            addPipeline: 'Add a new pipeline component',
            add: 'Add',
            addColumnMapping: 'Add column mapping',
            replaceCredentials: 'Replace credentials',
            addHttpCode: 'Add HTTP code',
            addNotification: 'Add notification',
            testNotification: 'Test notification',
            campaignToCampaign: 'Go to campaign',
            createPlan: 'Create Plan',
            close: 'Close',
        },
        messages: {
            noData: 'No data found',
            noOffersFound: 'No offers found for this advertiser',
            noContactsFound: 'No contacts found for this advertiser',
            noUsersFound: 'No users found for this advertiser',
            noParametersFound: 'No tracking parameters found for this advertiser',
            noTrackingParams: 'No tracking parameters',
            connectorUpdatedSuccessfully: 'Connector updated successfully',
            noTrackingDomainsFound: 'No tracking domains found for this site',
            noRolesFound: 'No roles found for this site',
            confirmDelete: 'Are you sure you want to delete this item?',
            deleteContactConfirm: 'Are you sure you want to delete {name}? This action cannot be undone.',
            deleteUserConfirm: 'Are you sure you want to delete {name}? This action cannot be undone.',
            deleteParameterConfirm: 'Are you sure you want to delete the parameter from "{from}" to "{to}"? This action cannot be undone.',
            deleteTrackingDomainConfirm: 'Are you sure you want to delete the tracking domain "{domain}"? This action cannot be undone.',
            deleteRoleConfirm: 'Are you sure you want to delete the role "{role}"? This action cannot be undone.',
            copySuccess: 'Link copied to clipboard',
            noTrackingDomains: 'No tracking domains found for this site or tracking domain is not enabled',
            geoRedirectActivated: 'Geo redirect activated',
            geoRedirectOffers: 'You must select at least one offer',
            geoRedirectPrelanders: 'You must select at least one prelander',
            notificationTestError: 'Notification test failed',
        },
        validation: {
            amBdDifferent: 'Account Manager and Business Dev must be different users.',
            passwordsMatch: 'Passwords must match',
            passwordMinLength: 'Password must be at least 8 characters',
            authRequestRequiredFirst: 'Auth request is required first',
            googleSheetsAuthRequiredFirst: 'Google Sheets Auth is required first',
            pipeAlreadyExists: 'This pipeline component is already added',
            integrationTypeChangeConfirm: 'Changing integration type will replace your current pipeline. Continue?',
            googleSheets: {
                credentialsConfigured: 'Service account credentials are configured',
                invalidJson: 'Invalid JSON — check the service account file',
                testWarning: 'This test runs the full pipeline and may append a test row to your spreadsheet. Continue?',
            },
            cappingReached: 'Capping reached',
            notificationTestSuccess: 'Notification test successful',
            notificationTestError: 'Notification test failed',
        },
        filter: {
            search: 'Search...',
            searchConnector: 'Search name or endpoint...',
            allCategories: 'All Categories',
            allStatuses: 'All Statuses',
            allOrders: 'All Orders',
            allIntegrationTypes: 'All Types',
            allAdvertisers: 'All Advertisers',
            campaignType: 'Campaign Type',
            accountManager: 'Account Manager...',
            businessDev: 'Business Dev...',
        },
        model: {
            user: 'user',
            offer: 'offer',
            advertiser: 'advertiser',
            publisher: 'publisher',
            affiliate: 'affiliate',
            smartCpa: 'smart cpa',
            category: 'category',
            campaign: 'campaign',
            customPayout: 'custom payout',
            customOfferRevenue: 'custom offer revenue',
            order: 'order',
            lead: 'lead',
            site: 'site',
            filter: 'Filter',
            connector: 'Connector',
            contact: 'Contact',
            parameter: 'Parameter',
            prelander: 'prelander',
            trackingDomain: 'Tracking Domain',
            profile: 'profile',
            targetingBehaviour: 'Targeting behaviour',
            customCapping: 'custom capping',
            migrationIssue: 'migration issue',
        },
        migrationIssues: {
            allStatuses: 'All statuses',
            statuses: {
                open: 'Open',
                acknowledged: 'Acknowledged',
                resolved: 'Resolved',
                ignored: 'Ignored',
            },
            clearSelected: 'Delete selected',
            clearFiltered: 'Delete all matching filters',
            bulkStatusLabel: 'Set selected to',
            applyStatusToSelected: 'Apply status',
            statusUpdated: 'Status updated.',
            statusUpdateError: 'Could not update status.',
            bulkDeleted: 'Issues removed.',
            bulkDeleteError: 'Could not delete issues.',
            confirmBulkDeleteTitle: 'Delete selected issues?',
            confirmBulkDelete: 'This will permanently delete the selected rows.',
            confirmClearFilteredTitle: 'Delete all issues matching current filters?',
            confirmClearFiltered: 'This will permanently delete every migration issue for site id {site} that matches the current filters (including message search).',
            show: 'Show',
            tableHint:
                'Stage, source, full message, and JSON payload are shown in the detail view — use the eye icon on each row.',
            issueDetail: 'Migration issue',
            detailSummary: 'Summary',
            detailSource: 'Source',
            detailMessage: 'Full message',
            detailPayload: 'Payload',
            detailIssueable: 'Related record',
            detailTimestamps: 'Timestamps',
            noPayload: 'No payload',
        },
        alerts: {
            passwordChange: 'To change your password, you must provide your current password for security verification.',
        },
        alert: {
            fetch: {
                error: "Couldn't load {model} options — try reloading the page.",
            },
            add: {
                success: 'The {model} was added successfully!',
                error: "The {model} wasn't added!",
            },
            edit: {
                success: 'The {model} was updated successfully!',
                error: "The {model} wasn't updated!",
            },
            delete: {
                title: 'Are you sure you want to delete it?',
                confirm: 'Yes, do it!',
                cancel: 'Cancel',
                success: 'The {model} was deleted successfully!',
                error: "The {model} wasn't deleted!",
            },
            enable: {
                success: 'The {model} "{domain}" was enabled successfully!',
                error: "The {model} wasn't enabled!",
            },
            custom: {
                extraParams: {
                    exists: "* This filter or extra param already exists!",
                    mandatory: "* This extra param already exists!",
                }
            }
        },
    },
}

export default admin
